import React, { useState } from "react";
import "./styles.css"; // Custom styles for the app
import { AirbudsYearlyHeader } from "./component/storyHeader";
import HorizontalPager from "./component/verticalScrollView";
import { ActionButton, ActionButtonFull } from "./component/buttons";
import { useData } from "./data/dataContext";
import { TopArtistCard } from "./component/topArtistCard";
import { useNavigate } from "react-router";

import { motion, animate } from "motion/react";
import { ComebackMessage } from "./comebackToUnlock";
import { EmptyScreen } from "./validation/validation";

export const ArtistItem = ({ data }) => {
  var title = "";
  var artwork = "";
  var isTop = false;

  if (data.artist_id) {
    title = data.artist_id.name;
    artwork = data.artist_id.artwork;
    isTop = data.rank < 10;
  }

  return (
    <div className="artist-item-container">
      <div>
        {artwork && (
          <img
            referrerPolicy="no-referrer"
            src={artwork}
            alt={title}
            className="artist-item-cover artist-capsule"
          />
        )}

        {isTop && (
          <img
            src={require("./assets/img/badge.svg")}
            alt="top badge"
            className="artist-item-badge"
          />
        )}
      </div>

      {title && <h2 className="artist-item-title">{title}</h2>}
    </div>
  );
};

export const TopArtistList = ({}) => {
  const { data } = useData();
  const navigate = useNavigate();
  const [selectedArtist, setSelectedArtist] = useState(null);
  const [showLastMessage, setShowLastMessage] = useState(false);

  if (!data) {
    return (
      <EmptyScreen text="loading..." closeAction={() => navigate("/menu")} />
    );
  }

  if (showLastMessage) {
    return (
      <ComebackMessage
        featureText="Come back tomorrow to unlock your next stat: Music Match of the year"
        next={() => {}}
      />
    );
  }

  return (
    <div className="app-top-artist-list-container">
      <div className="app-artist-top">
        <div className="app-top-artist-list">
          <h4 className="top-artist-list-instruction">
            Select from your most played artists to discover your ranking
          </h4>

          <HorizontalPager
            data={data}
            showArtist={(item) => {
              setSelectedArtist(item);
            }}
          />
        </div>

        <div className="buttons">
          <button onClick={() => setShowLastMessage(true)}>
            {" "}
            <ActionButton title="next" />
          </button>
        </div>
      </div>

      {selectedArtist && (
        <motion.div
          key="step-1"
          className="app-artist-modal"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1.0 }}
          exit={{ opacity: 1, scale: 0 }}
          transition={{
            duration: 0.5,
            delay: 0.0,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <TopArtistCard data={selectedArtist} />
          <button onClick={() => setSelectedArtist(null)}>
            <ActionButton title="close" />
          </button>
        </motion.div>
      )}
      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
      />
    </div>
  );
};
